// Most visitors have no agent context. They get only this small loader: the tools
// (a separate chunk, about 14 KB brotli) load only when a model context exists.
import { resolveModelContext } from './webmcp/model-context.js';

const MODEL_CONTEXT_ATTEMPTS = 50;
const MODEL_CONTEXT_RETRY_MS = 100;

async function waitForModelContext() {
  for (let attempt = 0; attempt < MODEL_CONTEXT_ATTEMPTS; attempt += 1) {
    const modelContext = resolveModelContext();
    if (modelContext) return modelContext;
    await new Promise((resolve) => setTimeout(resolve, MODEL_CONTEXT_RETRY_MS));
  }
  return null;
}

async function initializeWebMcp() {
  window.__IPPODO_WEBMCP__ = {
    supported: null,
    registered: [],
    status: 'waiting',
  };
  const modelContext = await waitForModelContext();
  if (!modelContext) {
    window.__IPPODO_WEBMCP__ = {
      supported: false,
      registered: [],
      status: 'unavailable',
    };
    return;
  }

  const previousController = window.__IPPODO_WEBMCP__?.controller;
  if (previousController instanceof AbortController) previousController.abort();

  try {
    const { registerIppodoWebMcpTools } = await import('./webmcp/tools.js');
    window.__IPPODO_WEBMCP__ = await registerIppodoWebMcpTools(modelContext);
    window.__IPPODO_WEBMCP__.status = 'registered';
  } catch (error) {
    window.__IPPODO_WEBMCP__ = {
      supported: true,
      registered: [],
      status: 'error',
      error: error.message,
    };
    console.warn('[webmcp] Unable to register Ippodo tools:', error);
  }
}

initializeWebMcp();
